import { Fragment, useState, useEffect } from 'react';

import { MegaMenu } from 'primereact/megamenu';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Column } from 'primereact/column';

import { OrderService } from '../../hoa-don/OrderService';
import { InvoiceDetailReportService as Service } from './InvoiceDetailReportService';
import { ConfigReportService } from '../ConfigReportService';

import { useDataTable } from '../../../shared/hooks/DataTable';
import { DialogView } from '../../hoa-don/component/DialogView';
import { DialogSendEmail } from '../../hoa-don/component/DialogSendEmail';
import { Filter } from '../filter';
import { FormatDisplay } from '../../../shared/format';
import EventEmitter from '../../../utils/EventEmitter';

import { ConfigColumns } from '../../../shared/component/ConfigColumns';
import { FilterDetail } from '../filter-detail';
import { CONSTANT } from '../../../Constant';

export default function ChiTietHoaDon() {

  const [displayFilter, setDisplayFilter] = useState(null);
  const [invoiceForm, setInvoiceForm] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [requiredParams, setRequiredParams] = useState(null);

  const [displayView, setDisplayView] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [displayCancel, setDisplayCancel] = useState(false);

  const [columns, setColumns] = useState([]);
  const [columnsState, setColumnsState] = useState(0);
  const [footerColumnGroup, setFooterColumnGroup] = useState(null);

  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let hasSumCol = columns?.filter(column => column.sum?.trim())?.length > 0;
    if (hasSumCol) {
      setFooterColumnGroup(<ColumnGroup>
        <Row>
          <Column style={{ minWidth: '40px', maxWidth: '40px', border: 0 }} />
          {
            columns.map((_column, index) => {
              if (_column.sum) {
                return <Column key={index} footer={FormatDisplay.number(summary ? summary[_column.sum] : 0)} style={{ justifyContent: 'end', minWidth: `${_column.width}px`, maxWidth: `${_column.width}px` }} />
              }
              return <Column key={index} style={{ minWidth: `${_column.width}px`, maxWidth: `${_column.width}px`, border: 0, borderLeft: '1px solid #dee2e6' }} />
            })
          }
        </Row>
      </ColumnGroup>);
    } else {
      setFooterColumnGroup(null);
    }
  }, [columns, summary]);

  const downloadExcel = () => {
    requiredParams.typeOrder = 1;
    Service.downloadExcel(requiredParams).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-chi-tiet-don-hang-ban-ra.xlsx`;
      link.click();
    });
  }
  const downloadCreatorNameExcel = () => {
    requiredParams.typeOrder = 1;
    Service.downloadCreatorNameExcel(requiredParams).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-theo-ten-nguoi-tao-don-hang.xlsx`;
      link.click();
    });
  }
  const downloadProductCodeExcel = () => {
    requiredParams.typeOrder = 1;
    Service.downloadProductCodeExcel(requiredParams).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-theo-ma-hang-hoa-don-hang.xlsx`;
      link.click();
    });
  }
  const downloadGroupExcel = () => {
    Service.downloadGroupExcel(requiredParams).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-nhom-theo-hoa-don.xlsx`;
      link.click();
    });
  }

  useEffect(() => {
    const showDialogSendEmail = (dataInvoice) => {
      setSelectedItems(dataInvoice);
      setDisplaySendEmail(true);
    };
    const eventsshowDialogSendEmail = EventEmitter.addListener("showDialogSendEmail", showDialogSendEmail);
    return () => {
      eventsshowDialogSendEmail.removeListener("showDialogSendEmail", showDialogSendEmail);
    }
  });

  const send = (item) => {
    setSelectedItems(item);
    setDisplayView(true);
  }
  const search = (params) => {
    setRequiredParams(params);
    setDisplayFilter(false);
    params.typeOrder = 1;
    Service.getSummary(params).then(data => {
      setSummary(data);
    });
  }

  const actions = [
    { label: 'Lọc dữ liệu', icon: 'pi pi-fw pi-filter', className: 'iam-toolbar iam-toolbar-secondary', command: () => setDisplayFilter(true) },
    // {label: 'Xem in PDF', icon: 'pi pi-fw pi-file-pdf', className: 'iam-toolbar iam-toolbar-secondary', command: downloadPdf},
    { label: 'Kết xuất excel', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadExcel },
    { label: 'Kết xuất excel (Nhóm theo người tạo) ', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadCreatorNameExcel },
    { label: 'Kết xuất excel (Nhóm theo mã hàng hóa) ', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadProductCodeExcel },
  ];

  const { render: renderDataTable, selectedItems, setSelectedItems } = useDataTable({
    columns,
    columnsState,
    indexColumnWidth: 40,
    getList(params: any): Promise<any> {
      params.typeOrder = 1;
      return Service.getList(params);
    },
    footerColumnGroup,
    requiredParams
  });

  const hardColumns = {
    invoiceNumber: {
      dataType: 'custom', customCell(rowData: any): any {
        return <span className={`underline send-tax-status send-tax-status-3`} onClick={() => send(rowData)}>{rowData.invoiceNumber}</span>;
      }
    },
    invoiceStatus: {
      filterType: 'multiselect', filterOptions: OrderService.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
        return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{OrderService.invoiceStatuses[rowData.invoiceStatus]?.label}</span>;
      }
    },
    sendTaxStatus: {
      filterType: 'multiselect', filterOptions: OrderService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
        if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
          return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{OrderService.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
        return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{OrderService.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
      }
    },
    buyerLegalName: {
      minWidth: 250, dataType: 'custom', customCell(rowData: any): any {
        return rowData.buyerLegalName || rowData.buyerDisplayName;
      }
    },
    sendEmail: { filterType: 'boolean', dataType: 'boolean' }
  };

  const getConfig = () => {
    return ConfigReportService.get(CONSTANT.ORDER_DETAIL_OUT).then(({ items }) => items);
  }

  const setConfig = items => {
    return ConfigReportService.set(CONSTANT.ORDER_DETAIL_OUT, items);
  }

  const restoreConfig = () => {
    return ConfigReportService.restore(CONSTANT.ORDER_DETAIL_OUT);
  }

  return (
    <Fragment>
      <MegaMenu model={actions} end={
        <ConfigColumns hardColumns={hardColumns} get={getConfig} set={setConfig} restore={restoreConfig} setColumns={setColumns} setColumnsState={setColumnsState} />
      } />
      <FilterDetail header="Báo cáo chi tiết đơn hàng" display={displayFilter} setDisplay={setDisplayFilter} search={search} invoiceForm={invoiceForm} />
      {renderDataTable()}
      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel} setInvoiceStatus={setInvoiceStatus} />
      <DialogSendEmail display={displaySendEmail} setDisplay={setDisplaySendEmail} selectedItems={selectedItems} />
    </Fragment>
  );
}